import React, { useCallback, useEffect, useState } from 'react';
import { Cascader } from 'antd';
import axios from 'axios';
import CascaderOptionType from 'antd/es/cascader';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface ZipcodeProps {
  value?: string[];
  zipcode?: string;
  type?: string;
  reset?: number;
  style?: React.CSSProperties;
  filter?: string;
  onChange?: (value: string[]) => void;
}

interface ZipOption {
  value: string;
  label: string;
  isLeaf?: boolean;
  loading?: boolean;
  children?: ZipOption[];
  disabled?: boolean;
}

const Zipcode: React.FC<ZipcodeProps> = ({ value: propValue = [], style, onChange }) => {
  const [zipcodeList, setZipcodeList] = useState<ZipOption[]>([]);

  useEffect(() => {
    loadFirst();
  }, []);

  useEffect(() => {
    onChange?.(propValue);
  }, [propValue]);

  const loadFirst = useCallback(async () => {
    try {
      const {
        result: { data },
      } = await API.get({ apiVersion: 'api' })(`/address/full`);
      const children = data.map((province: any) => {
        return {
          value: province.no,
          label: province.name,
          children: (province.districts || []).map((district: any) => {
            return {
              value: district.no,
              label: district.name,
              children: (district.streets || []).map((sub: any) => {
                return {
                  value: sub.no,
                  label: sub.name,
                };
              }),
            };
          }),
        };
      });
      setZipcodeList(children);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const handleChange = (val: string[] | undefined) => {
    if (val) {
      onChange?.([...val]);
    } else {
      onChange?.([]);
    }
  };

  return (
    <Cascader
      value={propValue}
      options={zipcodeList}
      placeholder="Хаяг сонгоно уу"
      style={style?.width ? { width: style.width } : {}}
      onChange={handleChange}
    />
  );
};

export default Zipcode;
